<!-- Product Details Container -->
<div class="product-details-container">
  <!-- Header Section -->
  <div class="product-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="product-title">
          <i class="pi pi-box mr-3"></i>
          Product Details
        </h1>
        <p class="product-subtitle">
          Complete information for {{ data?.description }}
        </p>
      </div>
      <div class="header-right">
        <div class="product-status">
          <i class="pi pi-check-circle status-icon"></i>
          Available
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="product-content">
    <!-- Product Image and Basic Info Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-image mr-2"></i>
          Product Overview
        </h2>
      </div>

      <div class="product-overview">
        <div class="product-image-section">
          <div class="image-container">
            <img
              [src]="data?.image_url || 'assets/images/placeholder-product.png'"
              [alt]="data?.description"
              class="product-image"
            />
          </div>
        </div>

        <div class="product-basic-info">
          <div class="info-card">
            <div class="info-label">Product Name</div>
            <div class="info-value">{{ data?.description }}</div>
          </div>

          <div class="info-card">
            <div class="info-label">Stock Item Code</div>
            <div class="info-value">{{ data?.stock_item_code }}</div>
          </div>

          <div class="info-card">
            <div class="info-label">Product ID</div>
            <div class="info-value">{{ data?.product_id }}</div>
          </div>

          <div class="info-card">
            <div class="info-label">Size</div>
            <div class="info-value">{{ data?.size }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Details Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-info-circle mr-2"></i>
          Product Information
        </h2>
      </div>

      <div class="product-details-grid">
        <div class="detail-card">
          <div class="detail-icon">
            <i class="pi pi-tag"></i>
          </div>
          <div class="detail-content">
            <div class="detail-label">Description</div>
            <div class="detail-value">{{ data?.description }}</div>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon">
            <i class="pi pi-box"></i>
          </div>
          <div class="detail-content">
            <div class="detail-label">Pack Size</div>
            <div class="detail-value quantity-value">{{ data?.quantity }}</div>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon">
            <i class="pi pi-ruler"></i>
          </div>
          <div class="detail-content">
            <div class="detail-label">Dimensions</div>
            <div class="detail-value">{{ data?.size }}</div>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon">
            <i class="pi pi-hashtag"></i>
          </div>
          <div class="detail-content">
            <div class="detail-label">Stock Code</div>
            <div class="detail-value">{{ data?.stock_item_code }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pricing Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-dollar mr-2"></i>
          Pricing Information
        </h2>
      </div>

      <div class="pricing-container">
        <div class="pricing-card">
          <div class="pricing-header">
            <h3 class="pricing-title">Cost Breakdown</h3>
          </div>

          <div class="pricing-details">
            <div class="price-row">
              <div class="price-label">Cost (excl. VAT):</div>
              <div class="price-value">
                {{ data?.cost_excl_vat | currency : "R" }}
              </div>
            </div>

            <div class="price-row">
              <div class="price-label">VAT Amount:</div>
              <div class="price-value">
                {{ data?.cost_incl_vat - data?.cost_excl_vat | currency : "R" }}
              </div>
            </div>

            <div class="price-divider"></div>

            <div class="price-row total">
              <div class="price-label">Cost (incl. VAT):</div>
              <div class="price-value">
                {{ data?.cost_incl_vat | currency : "R" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons Section -->
    <div class="content-section action-section">
      <div class="action-buttons">
        <button class="action-btn secondary" (click)="closeDialog()">
          <i class="pi pi-times mr-2"></i>
          Close
        </button>
        <!-- <button class="action-btn primary" (click)="addProductToCart(data)">
          <i class="pi pi-shopping-cart mr-2"></i>
          Add to Cart
        </button> -->
      </div>
    </div>
  </div>
</div>
